// extracted by mini-css-extract-plugin
export default {"bookmark_shortcut_button":"BookmarkShortcutButton_bookmark_shortcut_button__RcYX1"};